
import React, { useEffect, useState } from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import Text from '../../common/client/components/Text';

import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoVlastnici from './ObjectInfoVlastnici';
import ObjectInfoSearch from './ObjectInfoSearch';
import ToolbarCommandButton from './ToolbarCommandButton';

const SearchVlastnikParams = (props) => {

    const [params, setParams] = useState({name: ''});

    useEffect(() => {
        if (props.onChangeParams) {
            props.onChangeParams(params);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    const handleChangeName = (event) => {
        setParams({
            ...params,
            name: event.target.value
        });
    }

    return (
        <TextField
            label="Jméno / Název (vyhledává v celém textu)"
            value={params.name}
            onChange={handleChangeName}
        />
    );
}

const ObjectInfoSearchVlaParams = (props) => {

    const handleChangeParams = (params) => {
        if (props.onChangeParams) {
            props.onChangeParams(params);
        }
    }

    const handleSearchClick = () => {
        if (props.onSearchClick) {
            props.onSearchClick();
        }
    }

    return (
        <React.Fragment>
            <ObjectInfoTitle title="VYHLEDÁVÁNÍ VLASTNÍKŮ" />
            {props.params
                ? <React.Fragment>
                    <SearchVlastnikParams
                        params={props.params}
                        onChangeParams={handleChangeParams}
                    />
                    <ToolbarCommandButton items={[{
                        text: 'Vyhledat',
                        title: 'Vyhledat vlastníky podle zadaných parametrů',
                        onClick: handleSearchClick
                    }]}/>
                    {props.loading
                        ? <Text>Vyhledávám vlastníky...</Text>
                        : null
                    }
                </React.Fragment>
                : <Text>Načítám parametry pro vyhledávání...</Text>
            }
        </React.Fragment>
    );
}

const ObjectInfoSearchVlastnik = (props) => {
    return (
        <ObjectInfoSearch
            searchType="VLA"
            paramsClass={ObjectInfoSearchVlaParams}
            resultClass={ObjectInfoVlastnici}
            resultPropName="opsub"
        />
    );
}

export default ObjectInfoSearchVlastnik;
